import { useStore, useStoreActions } from "../../../contexts";
import { Button } from 'seagull';
import { StepPage } from "../../components/StepPage";
import { AgreementTerms } from "../AgreementTerms/AgreementTerms";
import { COBStep, getIsAllowedToSIgn, getNextStepButtonText, getStepName, isApproveProposalDisabled } from "../ClientOnboarding.utils";
import { useResponsive } from "../../contexts";
import ApproveProposalButton from "../../components/ApproveProposalButton";
import { useCobConfig } from "../CobConfigContext";
import { selectors } from "../../../store/state-selectors";
import { jsx as _jsx } from "react/jsx-runtime";
export default function ApproveTermsStep(_ref) {
  let {
    isLastStep,
    selectedBundleID,
    disabledReason,
    approveAgreementStatus,
    selectedOptionalServices,
    previewStatus,
    onDone,
    onBack,
    approveAgreement
  } = _ref;
  const {
    relationship,
    isPreview
  } = useCobConfig();
  const {
    logBI
  } = useStoreActions();
  const {
    isDesktop
  } = useResponsive();
  const userId = useStore(selectors.user.id);
  const role = useStore(selectors.user.role);
  const nextStepButtonText = getNextStepButtonText(COBStep.approveTerms, relationship);
  const isAllowedToSign = getIsAllowedToSIgn({
    relationship,
    userId,
    role
  });
  const disabled = isApproveProposalDisabled(relationship.isSample || isPreview ? isPreview : !isAllowedToSign, disabledReason, userId, relationship);
  return /*#__PURE__*/_jsx(StepPage, {
    header: getStepName(COBStep.approveTerms),
    primaryBtn: isLastStep ? /*#__PURE__*/_jsx(ApproveProposalButton, {
      onDone: approveAgreement,
      previewStatus: previewStatus,
      isDesktop: isDesktop,
      relationship: relationship,
      testid: (relationship.isSample ? 'test-agreement-' : '') + 'step2-next-btn',
      disabled: disabled || approveAgreementStatus === 'loading'
    }) : /*#__PURE__*/_jsx(Button, {
      "data-testid": (relationship.isSample ? 'test-agreement-' : '') + 'step2-next-btn',
      onClick: () => {
        !isPreview && logBI(10822);
        onDone();
      },
      children: nextStepButtonText
    }),
    disabledReason: disabled ? disabledReason : undefined,
    errorTestid: "step2-next-error",
    onBackBtnClick: onBack,
    backBtnTestid: (relationship.isSample ? 'test-agreement-' : '') + 'step2-back-btn',
    testid: "approve-terms-step",
    children: /*#__PURE__*/_jsx(AgreementTerms, {
      relationship: relationship,
      selectedBundleID: selectedBundleID,
      selectedOptionalServices: selectedOptionalServices
    })
  });
}